window.initProductSwiper = function() {
  const swiperEl = document.querySelector('.mySwiper');
  if (!swiperEl) return;

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
  const enableLoop = slideCount >= 2;

  const swiperConfig = {
    slidesPerView: 1.6,
    centeredSlides: true,
    centeredSlidesBounds: true,
    loop: enableLoop,
    loopedSlides: enableLoop ? 4 : null,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    speed: 600,
    spaceBetween: 0,

    pagination: {
      el: '#ProductImages .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      0: { 
        slidesPerView: 1, 
        spaceBetween: 0,
        pagination: { enabled: true } 
      },
      1024: { 
        slidesPerView: 1.6, 
        spaceBetween: 0,
        pagination: { enabled: false } 
      },
    },

    on: {
      init: function() {
        setTimeout(() => {
          this.update();
          if (this.params.loop) {
            this.slideToLoop(0, 0);
          }
        }, 100);
      }
    }
  };

  window.productSwiper = new Swiper('.mySwiper', swiperConfig);
};

document.addEventListener('DOMContentLoaded', window.initProductSwiper);